<template>
  <div class="signup">
    <img src="@/assets/logo_all_blue.png" class="logo" />
    <div class="inputs">
      
      <dg-input
        type="text"
        v-model="formData.name"
        placeholder="Full name"
        icon="user"
        :error="errors.name"
        validate
        @validate="validated.name = $event"/>

      <dg-input
        type="email"
        placeholder="E-mail"
        icon="envelope"
        validate
        v-model="formData.email"
        :error="errors.email"
        @validate="validated.email = $event"/>
        
      <transition name="fade">
        <div class="step-2" v-if="step > 1">
          <dg-input type="phone" v-model="formData.phoneNumber" placeholder="Phone" icon="phone"/>
          <dg-input type="text" v-model="formData.address" placeholder="Address" icon="map-pin" :error="errors.address"/>
          <div class="split">
            <dg-input type="text" v-model="formData.city" placeholder="City" icon="info" :error="errors.city" compactError/>
            <dg-input type="text" v-model="formData.zip" placeholder="Zip code" :error="errors.zip" compactError/>
          </div>

          <div class="split">
            <picker
              :api="$api.country().index"
              :error="errors.currencyId"
              v-model="formData.countryId"
              class="signup-country-picker"
              value-key="id"
              placeholder="Select your country"
              @pick="setCurrencyId"
              icon="globe" />
            <picker
              v-if="formData.countryId"
              :api="$api.currencies.index"
              :error="errors.countryId"
              v-model="formData.currencyId"
              class="signup-country-picker"
              value-key="id"
              placeholder="Choose your currency" />
          </div>

          <div class="split">
            <dg-input type="password" v-model="formData.password" placeholder="Password" icon="lock" :error="errors.password" compactError/>
            <dg-input type="password" v-model="formData.confirmPassword" placeholder="Confirm password" :error="errors.confirmPassword" compactError/>
          </div>
        </div>

      </transition>

      <el-button :loading="loading" type="primary" class="signup-button" @click="nextStep">{{ step > 1 ? 'Sign up' : 'Continue' }}</el-button>
      <p v-if="errors.general" class="error-msg">{{ errors.general }}</p>
      <router-link to="signin" tag="button" class="el-button el-button--text signin-button">Already registered? Sign in</router-link>

    </div>
  </div>
</template>

<script>
import Picker from '@/components/shared/CollectionPicker'

export default {
  name: 'Signup',
  components: { Picker },
  data () {
    return {
      step: 1,
      loading: false,
      validated: {
        email: false,
        name: false
      },
      errors: {
        name: null,
        email: null
      },
      formData: {
        name: '',
        email: '',
        address: '',
        zip: '',
        city: '',
        phoneNumber: '',
        password: '',
        confirmPassword: '',
        countryId: null,
        currencyId: null
      }
    }
  },
  computed: {
    allValidated () {
      return this.validated.email && this.validated.name
    }
  },
  methods: {
    validateFormData () {
      if (!this.validated.email) {
        this.errors.email = 'Please provide a valid e-mail'
      }
      if (!this.validated.name) {
        this.errors.name = 'Please tell us your full name'
      }
    },
    setCurrencyId (country) {
      this.formData.currencyId = country.currency.id
    },
    setErrors (errors) {
      this.errors.general = errors[''] || null
      for (let k in errors) {
        this.errors[k] = errors[k]
      }
    },
    nextStep () {
      if (this.step === 2) {
        this.signup()
      } else {
        this.validateFormData()

        if (this.allValidated) {
          this.errors.name = null
          this.errors.email = null
          this.step++
        }
      }
    },
    async signup () {
      this.loading = true
      let endpoint = this.$api.auth.signUp + (this.$route.query.hasOwnProperty('access') ? '?access=' + this.$route.query.access : '')

      if (!this.allValidated) {
        this.validateFormData()
        this.loading = false
        return
      }

      try {
        const response = await this.$http.post(endpoint, this.formData)
        this.$auth.setToken(response.data.token)
        this.$router.push((this.redirect && this.redirect.length > 0) ? this.redirect : '/dashboard/')
      } catch (error) {
        this.setErrors(error.response.data)
      }
      this.loading = false
    }
  },
  created () {
    if (this.$auth.isLoggedIn()) {
      this.$router.push((this.redirect && this.redirect.length > 0) ? this.redirect : '/dashboard/')
    }
  },
  mounted () {
    this.redirect = this.$route.query.redirect
  }
}
</script>

<style lang="scss" scoped>
  .signup {
    padding: 20px 0px;
    height: 100vh;
    max-height: 100vh;
    overflow-y: scroll;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    @media screen and (max-height: 700px) {
      justify-content: flex-start;
    }
  }

  .logo {
    width: 160px;
    height: auto;
    display: block;
    margin: 0 auto;
    margin-bottom: 50px;
  }

  .inputs {
    width: 400px;
    margin: 0 auto;

    @include breakpoint (xs) {
      width: 300px;
    }

    .dg-input {
      margin-bottom: 20px;
    }

    .split {
      display: flex;
      justify-content: space-between;
      align-items: center;

      div {
        flex: 1;
      }
    }
  }

  .signup-country-picker {
    margin-bottom: 20px;
  }

  .signup-button, .signin-button {
    width: 100%;
    display: block;
    margin-top: 20px;
  }

  .signin-button {
    font-size: 14px !important;
    margin-left: 0px;
    margin-top: 20px;
  }

  .error-msg {
    color: red;
    font-size: 14px;
    margin-top: 5px;
  }

</style>



// WEBPACK FOOTER //
// src/components/front/Signup.vue